import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { FilterProvider } from "../../context/FilterContext";
import XSurvey from "./Dashboard/dashboard";
import Modules from "./Settings/Modules";

export default function SurveyApp() {
  const [activeTab, setActiveTab] = useState("dashboard");

  return (
    <FilterProvider>
      <div className="survey-app">
        <Tabs
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="mb-3"
          style={{ borderBottom: "2px solid #e2e8f0" }}
        >
          <Tab eventKey="dashboard" title="Dashboard">
            <XSurvey />
          </Tab>
          <Tab eventKey="settings" title="Settings">
            <Modules />
          </Tab>
        </Tabs>
      </div>
    </FilterProvider>
  );
}
